export default ({ app }) => {
  // used by webpush worker to navigate preventing reload
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener('message', function(event) {
      if (event.data.action === 'navigate') {
        app.router.push(event.data.url)
      }
    })
  }
}
